import { StyledRow } from '@/shared/styles';
import { getAccessibilityScoreDic } from '../AccessibilityScore.consts';
import { ScoreCard } from './ScoreCard';
import { StyledScoreCard } from './ScoreCard.styles';

export const DesktopStoreCards: React.FC = () => {
  return (
    <StyledRow $width="100%" $gap={20}>
      {Object.keys(getAccessibilityScoreDic()).map((scoreName, i) => (
        <StyledScoreCard key={`score${i}`}>
          <ScoreCard $scoreName={scoreName} />
        </StyledScoreCard>
      ))}
    </StyledRow>
  );
};
